import gql from "graphql-tag";

export const GET_NOT_AUTHORIZED_WO_EXAMINER_LIST = gql`
  query notAuthorizedListWoExaminer {
    notAuthorizedListWoExaminer {
      employeeName
      contractCode
      orgUnit
      _id
    }
  }
`;
